"use client";

import React, { useEffect, useRef } from "react";
import { Youtube } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AtmosphereInFilm() {
  const containerRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || !videoRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.bottom > 0 && rect.top < windowHeight) {
        const distanceFromCenter = rect.top + rect.height / 2 - windowHeight / 2;
        const speed = 0.15;
        const translateY = distanceFromCenter * speed;
        videoRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section data-section-id="42338" id="schau-dich-bei-uns-um" className="![padding:144px_16px_144px_16px] md:![padding:144px_32px_144px_32px]">
  <div className="max-w-7xl mx-auto">
    <div className="relative h-[80vh] w-full rounded-[1rem] overflow-hidden">
      <video ref={videoRef} className="absolute inset-0 h-full w-full object-cover pointer-events-none" autoPlay muted loop playsInline preload="auto">
        <source src="https://perfect-duck.10web.cloud/wp-content/uploads/2026/04/Coworking-Reel-2.mp4" type="video/mp4" />
      </video>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent z-10 pointer-events-none" />

      {/* Content */}
      <div className="absolute inset-0 z-20 flex flex-col items-start justify-end p-10 md:p-16">
        <span className="mb-4 inline-block rounded-full bg-white/10 backdrop-blur-sm border border-white/20 px-5 py-2 text-sm font-semibold uppercase tracking-widest text-white/80">
          Virtueller Rundgang
        </span>
        <h2 className="font-sans text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tighter leading-[1.05] max-w-2xl">
          Schau dich bei<br />uns um.
        </h2>
      </div>
    </div>
  </div>
</section>;
}